import React from 'react'
import { connect } from 'react-redux'
import ReservationReport from './BetaReservationReport'
import { requestReport } from '../../api'
import moment from 'moment'
import { handleReportRequest } from '../../modules/report'
import { rateLimit } from '../../utils/rate-limit'
import { createDateRange, getUserTimezone } from '../../utils/dateUtils'
import { DateTime } from 'luxon'

// Get today's date in the user's selected timezone
const getTodayInUserTimezone = () => {
  const userTimezone = getUserTimezone()
  const now = DateTime.now().setZone(userTimezone)
  // Create moment from date components to avoid timezone conversion
  return moment({ year: now.year, month: now.month - 1, day: now.day })
}

class ReservationReportContainer extends React.Component {
  state = {
    startDate: getTodayInUserTimezone(),
    endDate: getTodayInUserTimezone(),
    status: undefined,
    searchArchived: false,
    isLoading: false,
  }

  reportName = '/api/reports/queue/reservationReportBeta'

  createQuery = function (type) {
    // Create timezone-aware date ranges using user's selected timezone
    const startRange = createDateRange(this.state.startDate)
    const endRange = createDateRange(this.state.endDate)

    return {
      type,
      startDate: startRange.start, // UTC ISO string (e.g., 2026-01-23T17:00:00.000Z)
      endDate: endRange.end,     // UTC ISO string (e.g., 2026-01-24T16:59:59.999Z)
      status: this.state.status,
      stationId: this.state.stationId,
      agentId: this.state.agentId,
      source: this.state.searchArchived ? 'archived' : undefined,
    }
  }

  handleDownloadPDF = () => {
    rateLimit(
      async () =>
        await handleReportRequest(
          requestReport(this.reportName, this.createQuery('pdf')),
        ),
      3000,
      (isLoading) => {
        this.setState((state) => ({
          ...state,
          isLoading,
        }))
      },
    )
  }

  handleDownloadCSV = () => {
    rateLimit(
      async () =>
        await handleReportRequest(
          requestReport(this.reportName, this.createQuery('csv')),
        ),
      3000,
      (isLoading) => {
        this.setState((state) => ({
          ...state,
          isLoading,
        }))
      },
    )
  }

  handleViewWebClick = () => {
    window.open(this.downloadHTMLLink(), '_blank')
  }

  downloadHTMLLink = () => {
    const url = new URL('/report/web', window.location.href)
    const query = this.createQuery()
    url.searchParams.set('name', 'reservationReportBeta')
    for (const key of Object.keys(query)) {
      if (query[key]) url.searchParams.set(key, query[key])
    }
    return url.href
  }

  handleFilterChange = (key, value) => {
    this.setState({
      ...this.state,
      [key]: value,
    })
  }

  statusOptions = [
    { label: 'COMPLETED', value: 'completed' },
    { label: 'NOSHOW', value: 'noShow' },
    { label: 'CANCELED', value: 'canceled' },
  ]

  isDownloadable = () => {
    if (
      this.state.isLoading ||
      !this.state.startDate ||
      typeof this.state.startDate !== 'object' ||
      !this.state.endDate ||
      typeof this.state.endDate !== 'object'
    )
      return false

    return this.state.startDate
      .startOf('day')
      .isBefore(this.state.endDate.endOf('day'))
  }

  render() {
    return (
      <ReservationReport
        onFilterChange={this.handleFilterChange}
        isDownloadable={this.isDownloadable()}
        onDownloadPDF={this.handleDownloadPDF}
        onDownloadCSV={this.handleDownloadCSV}
        onViewWebClick={this.handleViewWebClick}
        filter={this.state}
        startDateValid={this.startDateValid}
        endDateValid={this.endDateValid}
        statusOptions={this.statusOptions}
        auth={this.props.auth}
      />
    )
  }
}

export default connect((state) => ({ auth: state.auth }))(ReservationReportContainer)
